import { render, staticRenderFns } from "./ScoresModal.vue?vue&type=template&id=643ca4b9&"
import script from "./ScoresModal.vue?vue&type=script&lang=js&"
export * from "./ScoresModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports